export default "__VITE_ASSET__BGvji4B9__"